document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector(".boa-description-content");
  const readMoreBtn = document.querySelector(".boa-read-more-btn");

  if (description && readMoreBtn) {
    const initialHeight = description.scrollHeight;
    const maxHeight = parseInt(getComputedStyle(description).lineHeight) * 3;

    // Show button only if text exceeds the max height
    if (initialHeight > maxHeight) {
      readMoreBtn.classList.remove("hidden");

      let isExpanded = false;
      readMoreBtn.addEventListener("click", function () {
        isExpanded = !isExpanded;
        description.style.maxHeight = isExpanded ? "none" : maxHeight + "px";
        readMoreBtn.textContent = isExpanded ? "קראי פחות" : "קראי עוד";
      });
    }
  }
});
